import { Component } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {NavigationStart, Router} from "@angular/router";
import {AuthService} from "./core/services/auth.service";
import {LoginService} from "./login/services/login.service";
import {environment} from "src/environments/environment";
import * as moment from 'moment';

moment.updateLocale('de', {
  relativeTime: {
    future: 'in %s',
    past: 'vor %s',
    s: 'einigen Sekunden',
    ss: '%d Sekunden',
    m: 'einer Minute',
    mm: '%d Minuten',
    h: 'einer Stunde',
    hh: '%d Stunden',
    d: 'einem Tag',
    dd: '%d Tagen',
    M: 'einem Monat',
    MM: '%d Monaten',
    y: 'einem Jahr',
    yy: '%d Jahren'
  }
});

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  userCentricsInterval
  routeEvents = null;
  log = null;

  constructor(private auth: AuthService,
              private router: Router,
              private loginService: LoginService,
              private authService: AuthService) {}

  async ngOnInit() {
    this.getUserCentricsElement = this.getUserCentricsElement.bind(this);
    this.userCentricsInterval = setInterval(this.getUserCentricsElement, 50);
    this.addDevItem();

    this.routeEvents = this.router.events.subscribe(async event => {
      if (event instanceof NavigationStart && this.authService.isloggedIn?.value) {

        await this.loginService.hasValidAgbVersion().subscribe(res => {
          console.log('RES');
          console.log(res);
          if (res && res.validAgbVersion) {
            this.authService.hasValidAgbVersion.next(true);
          } else {
            this.authService.hasValidAgbVersion.next(false);
            this.router.navigateByUrl('agb')
          }
        }, (err) => {
          console.log('err')
          console.log(err)
        });
      }
    });

    setTimeout(() => {
      if (this.authService.isloggedIn?.value) {
        this.log = this.loginService.hasValidAgbVersion().subscribe(res => {
          if (res && res.validAgbVersion) {
            this.authService.hasValidAgbVersion.next(true);
          } else {
            this.authService.hasValidAgbVersion.next(false);
            this.router.navigateByUrl('agb')
          }
        },(err)=>{
          console.log(err)
        });
      }
    }, 1000)
  }

  addDevItem() {
    console.log(environment)
    if (environment.node_env && environment.node_env != 'release') {
      let elemDiv = document.createElement('div');
      elemDiv.style.cssText = 'position:absolute;top:44px;width:min(max(5vw, 50px), 100px);height:50px;opacity:0.7;z-index:1000;background:#FF0000;display:flex;align-items:center;justify-content:center;pointer-events:none;';
      let text = document.createElement("p");
      text.innerHTML = environment.node_env == 'master' ? 'DEV' : 'local';
      text.style.margin = 'unset';
      text.style.fontSize = 'min(max(2vw, 20px), 40px)';
      elemDiv.appendChild(text);
      document.body.appendChild(elemDiv);
    }
  }

  onDestroy() {
    clearInterval(this.userCentricsInterval);
  }

  stopTimer() {
    clearInterval(this.userCentricsInterval);
  }

  getUserCentricsElement() {
    const userCentrics = document.querySelector('#usercentrics-root');
    if (userCentrics) {
      const searchModuleRoot = userCentrics && userCentrics.shadowRoot;
      const button = searchModuleRoot.querySelector<HTMLElement>('button[data-testid="uc-privacy-button"]');
      if (button) {
        button.style.display = 'none';
        this.stopTimer();
      }
    }
  }
}
